import { MYLIBRARY_TEXTS } from "../../../utils/constants";
import { AllowedPath } from "../AdminBulkUpload";

export const getDisplayType = (path: AllowedPath | null): string => {
  switch (path) {
    case MYLIBRARY_TEXTS?.IMAGES_TEXT:
      return "Images";
    case MYLIBRARY_TEXTS?.PODCAST_TEXT:
      return "Podcast";
    case MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT:
      return "Videos";
    case MYLIBRARY_TEXTS?.EBOOK_PREFIX_LEARNING_MATERIALS_TEXT:
    case MYLIBRARY_TEXTS?.EBOOK_PREFIX_QUESTION_BANK_TEXT:
    case MYLIBRARY_TEXTS?.EBOOK_PREFIX_EXAM_GUIDE_TEXT:
      return "Documents";
    default:
      return "Images, Videos, Documents and Audios";
  }
};


// Utility function for cleaner mapping
export const getFileType = (mimeType: string): string | null => {
  switch (mimeType) {
    case "application/pdf":
      return "pdf";
    case "text/csv":
      return "csv";
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "xlsx";
    case "application/vnd.ms-excel":
      return "xls";
    case "application/vnd.ms-powerpoint":
      return "ppt";
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "pptx";
    case "application/epub+zip":
      return "epub";
    case "application/msword":
      return "doc";
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "docx";
    default:
      return null;
  }
};
